var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "business-orders-file" },
    [
      _c(
        "svg",
        {
          staticClass: "business-orders-file__icon",
          attrs: { width: "90", height: "90" }
        },
        [_c("use", { attrs: { "xlink:href": "#file-download" } })]
      ),
      _c("h4", { staticClass: "business-orders-file__title" }, [
        _vm._v("\n        " + _vm._s(_vm.fileTitle) + "\n    ")
      ]),
      _c(
        "div",
        { staticClass: "business-orders-file__actions" },
        [
          _c(
            "a",
            {
              staticClass: "business-orders-file__action",
              attrs: { target: "_blank", href: _vm.downloadUrl }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("general.files.download")) +
                  "\n        "
              )
            ]
          ),
          !_vm.isPreview
            ? _c("div", {
                staticClass: "business-orders-file__action-separator"
              })
            : _vm._e(),
          !_vm.isPreview && _vm.$hasAccess("businessorders:write")
            ? _c(
                "base-button",
                {
                  staticClass: "business-orders-file__action",
                  attrs: { "as-link": "" },
                  on: { click: _vm.handleDeleteFileClick }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("general.delete")) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.isTabletSize ? _c("modals-container") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }